import { unique } from 'underscore'

import { Track } from '../../../@paco/entities/Track/Track'

import { formatDate } from '../../../helpers/date'

export default function getTracksByDate(
    tracks: Track[],
): { [date: string]: Track[] } {
    const format = 'yyyy-MM-dd'
    const dates = unique(tracks.map((track) => formatDate(track.checkInOutPeriod.start, format)))
    return dates.reduce((total: { [date: string]: Track[] }, date: string) => ({
        ...total,
        [date]: tracks.filter(track => formatDate(track.checkInOutPeriod.start, format) === date),
    }), {})
}
